module.exports = __webpack_public_path__ + "img/Calendar_Filled_24px_Icon.da2d866d.svg";